<!--  -->
<template>
  <div>
    <div v-if="skinCss === 1" class="examSeason">
      <div class="content">
        <p>别忘了完善一下考试信息呦~</p>
        <div class="exam">
          <div
            :class="{ active: examNum.name === item.name }"
            v-for="(item, i) in examList"
            :key="i"
            @click="choose(item)"
          >
            <b> {{ item.name }}</b>
          </div>
        </div>
      </div>
      <button class="btn" :class="{active:examNum.name}" @click="submit">保存</button>
    </div>
    <!--  一模一样的功能，样式不一样2  -->
    <div v-if="skinCss === 2" class="examSeason2">
      <div class="content content2">
        <div class="exam">
          <div
            :class="{ active: examNum.name === item.name }"
            v-for="(item, i) in examList"
            :key="i"
            @click="choose(item)"
          >
            <b> {{ item.name }}</b>
          </div>
        </div>
      </div>
      <button class="btn" :class="{active:examNum.name}" @click="submit">保存</button>
    </div>
    <!--  一模一样的功能，样式不一样3  -->
    <div v-if="skinCss === 3" class="examSeason3">
      <div class="content3">
        <div class="exam">
          <div
            :class="{ active: examNum.name === item.name }"
            v-for="(item, i) in examList"
            :key="i"
            @click="choose(item)"
          >
            <b> {{ item.name }}</b>
          </div>
        </div>
      </div>
      <button class="btn3" :class="{active:examNum.name}" @click="submit">保存</button>
    </div>
  </div>
</template>

<script>
import { reqNewUserRecord } from '@/api/login';
import { setBaseUrl } from '@/utils/tools';
export default {
  components: {},
  props:{
    skinCss: {
      type: Number,
      default: 1
    },
  },
  data() {
    return {
      examNum: {},
      examList: [
         {
          name: '26考研',
          key: 1117,
        },
        {
          name: '27考研',
          key: 1331,
        },
        {
          name: '其他',
          key: 0,
        },
      ],
      point: false
    };
  },
  computed: {},
  watch: {},
  methods: {
    choose(item) {
      this.examNum = item;
    },
    async submit() {
      if (!this.examNum.name) {
        this.$toast('请选择考试标签');
        return;
      }
      if (this.examNum.key === 0) {
        this.close();
        return;
      }
      if(this.point)return;
      this.point=true;
      const { code, msg } = await reqNewUserRecord({
        company: 1,
        labelTreeIdList: [this.examNum.key],
        userCenter: false,
      });
      if (code === 0) {
        this.close();
      } else {
        this.$toast(msg);
      }
      this.point=false
    },
    close() {
      this.$emit('closeRegisterAfter', true);
      if(this.skinCss===3){ window.location.href=`${setBaseUrl('')}/iform/index/69`}
    },
  },
  created() {},
  mounted() {},
};
</script>
<style lang="scss" scoped>
.examSeason {
  position: absolute;
  top: 480px;
  width: 100%;
}
.examSeason2 {
  position: absolute;
  top: 336px;
  width: 100%;
}
.examSeason3{
  position: absolute;
  top: 145px;
  width: 100%;
}
.content {
  width: 542px;
  height: 336px;
  margin: 40px auto;
  padding: 0 40px;
  background: #fff;
  border-radius: 32px;
  box-shadow: 0 24px 16px -14px rgba(230, 189, 121, 0.3);
  > p {
    padding: 32px 0;
    color: #733d08;
    font-weight: 500;
    font-size: 28px;
    line-height: 40px;
    text-align: center;
  }
  .exam {
    display: flex;
    flex-wrap: wrap;
    align-content: center;
    justify-content: flex-start;
    > div {
      width: 216px;
      margin-right: 30px;
      margin-bottom: 32px;
      text-align: center;
      border: 2px solid #d1d1d1;
      border-radius: 44px;
      > b {
        color: #333;
        font-weight: 400;
        font-size: 28px;
        line-height: 80px;
      }
    }
    > div:nth-child(2n) {
      margin-right: 0;
    }
    > div.active {
      background: #ff7f41;
      border:none;
      b {
        color: #ffff;
      }
    }
  }
}
.content.content2{
  background: #FFFFFF;
  box-shadow: 0px 0px 27px 0px rgba(239,172,68,0.15);
  border-radius: 30px;
  height: 331px;
  padding-top: 70px;
  box-sizing: border-box;
  margin-top: 0;
}
.examSeason3{
  .exam {
    display: flex;
    align-content: center;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 25px;
    > div {
      width: 181.4px;
      height: 59.6px;
      text-align: center;
      border: 2px solid #d1d1d1;
      background: #FFFFFF;
      border-radius: 44px;
      > b {
        color: #333;
        font-weight: 400;
        font-size: 28px;
        line-height: 59.6px;
      }
    }
    > div.active {
      background: #ff7f41;
      border:none;
      b {
        color: #ffff;
      }
    }
  }
}
.btn {
  display: block;
  width: 340px;
  margin: 0 auto;
  color: #fff;
  font-weight: 500;
  font-size: 32px;
  line-height: 88px;
  background: #ff7f41;
  border-radius: 44px;
  opacity: 0.5;
}
.btn3 {
  display: block;
  width: 270px;
  margin: 0 auto;
  color: #fff;
  font-weight: 500;
  font-size: 32px;
  line-height: 59.6px;
  background: #ff7f41;
  border-radius: 44px;
  opacity: 0.5;
  margin-top: 542px;
}
.btn.active{
  opacity: 1;
}
.btn3.active{
  opacity: 1;
}
</style>
